/* =============================================
   OXYGENWT — Custom Theme JS
   ============================================= */

(function () {
  'use strict';

  // ── Sticky header shadow on scroll ──
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ── Intersection Observer: fade-up animations ──
  const fadeEls = document.querySelectorAll('.fade-up');
  if (fadeEls.length) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    fadeEls.forEach((el) => observer.observe(el));
  }

  // ── Mobile menu toggle ──
  const hamburger = document.querySelector('.header-hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('is-open');
      hamburger.setAttribute('aria-expanded', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
  }

  // ── Quick-add to cart (AJAX) ──
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    const btn = form.querySelector('button[type="submit"]');
    if (!btn || btn.disabled) return;

    btn.textContent = 'Wordt toegevoegd…';
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          id:       form.querySelector('[name="id"]').value,
          quantity: parseInt(form.querySelector('[name="quantity"]').value, 10) || 1,
        }),
      });

      if (!res.ok) throw new Error();

      btn.textContent = '✓ Toegevoegd!';

      // Update cart count badge
      const countRes = await fetch('/cart.js');
      const cart = await countRes.json();
      document.querySelectorAll('.cart-count').forEach((el) => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });

      setTimeout(() => {
        btn.textContent = 'In winkelwagen';
        btn.disabled = false;
      }, 2000);

    } catch {
      btn.textContent = 'Probeer opnieuw';
      btn.disabled = false;
    }
  });

  // ── Newsletter form ──
  const nlForm = document.querySelector('.newsletter-form');
  if (nlForm) {
    nlForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const input = nlForm.querySelector('.newsletter-input');
      const btn   = nlForm.querySelector('.btn');
      if (!input || !btn) return;

      const email = input.value.trim();
      if (!email) return;

      btn.textContent = 'Even wachten…';
      btn.disabled = true;

      // Shopify customer accept-marketing via storefront
      try {
        const res = await fetch('/contact#newsletter-form', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({ form_type: 'customer', utf8: '✓', 'contact[email]': email }),
        });

        if (res.ok) {
          input.value = '';
          btn.textContent = '✓ Ingeschreven!';
          setTimeout(() => {
            btn.textContent = 'Inschrijven';
            btn.disabled = false;
          }, 3000);
        }
      } catch {
        btn.textContent = 'Probeer opnieuw';
        btn.disabled = false;
      }
    });
  }

})();
